import { render } from "./PortfolioIllustration.vue?vue&type=template&id=4ae27122&scoped=true"
import script from "./PortfolioIllustration.vue?vue&type=script&lang=js"
export * from "./PortfolioIllustration.vue?vue&type=script&lang=js"

import "./PortfolioIllustration.vue?vue&type=style&index=0&id=4ae27122&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae27122"]])

export default __exports__